import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { QRCodeInternalService } from 'src/app/shared/services/API/totem/qr-code-internal.service';
import { HealthUnitService } from 'src/app/shared/services/API/user/health-unit.service';
import { QRCode } from 'src/app/shared/services/models/totem/nps-message.model';
import { HealthUnitStruct } from 'src/app/shared/services/structs/user/health-unit.struct';
import { UtilService } from 'src/app/shared/services/util.service';

@Component({
  selector: 'app-redirect-page',
  templateUrl: './redirect-page.component.html',
  styleUrls: ['./redirect-page.component.css']
})
export class RedirectPageComponent implements OnInit {

  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private qrCodeInternalService: QRCodeInternalService,
    private healthUnitService: HealthUnitService,
    private utilService: UtilService,
  ) { }

  public healthUnitStruct: HealthUnitStruct;
  public qrCode: QRCode;

  public isLoading: boolean = false;
  public checkedGuid: boolean = false;
  public checkedLoading: boolean = false;

  public guid: string = '';

  ngOnInit(): void {
    this.qrCode = this.utilService.getQRCodeConfig();
    if (this.activatedRoute.snapshot.paramMap.get('guid')) {
      this.guid = this.activatedRoute.snapshot.paramMap.get('guid');
      if(!this.qrCode || this.qrCode.guid != this.guid) {
        this.utilService.cleanQRCodeConfig();
        this.getRedirect();
      } else {
        this.checkedLoading = true;
        this.checkedGuid = true;
        if(this.qrCode.idHealthUnit) {
          this.getHealthUnit(this.qrCode.idHealthUnit);
        }
      }
    }
  }

  getRedirect() {
    this.qrCodeInternalService.getvalidateQRCodeByGuid(this.guid).subscribe({
      next: (response) => {
        if (response.isError) {
          this.checkedLoading = true;
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this.qrCode = response.qrCode;

        if (this.qrCode != null)
          this.checkedGuid = true;

        this.utilService.setQRCodeConfig(response.qrCode);

        if(this.qrCode.guidNps && !this.qrCode.hasSelfTriage)
          this.goNps();

        if(!this.qrCode.guidNps && this.qrCode.hasSelfTriage)
          this.goSelfTriage();

        this.checkedLoading = true;
        
        if(this.qrCode.idHealthUnit)
          this.getHealthUnit(this.qrCode.idHealthUnit);
      },
      error: (error) => {
        this.checkedLoading = true;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  getHealthUnit(idHealthUnit: number) {
    this.healthUnitService.getHealthUnit(idHealthUnit).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this.healthUnitStruct = response.healthUnitStruct;
      },
      error: (error) => {
        console.log(error);
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  goSelfTriage() {
    this.router.navigate(['self-triage', 'protocol', 'idEpisode', this.qrCode.idEpisode]);
  }

  goNps() {
    this.router.navigate([`nps/${this.qrCode.guidNps}`]);
  }
}
